import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  headerSk: {
    marginBottom: "28px",
    height: "188px",
    backgroundColor: colors.darkGrey,
    borderRadius: "16px",
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      height: "270px",
    },
  },
  firstRow: {
    marginBottom: "10px",
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    height: "24px",
    marginBottom: "4px",
  },
  cardsWrapper: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    height: "280px",
  },
  cardSk: {
    paddingBottom: "8px",
    marginBottom: "20px",
    height: "280px",
    backgroundColor: colors.darkGrey,
    borderRadius: "16px",
    "--base-color": colors.darkGrey,
  },
});

export default styles;
